function formatMoney(cents, format = "") {
    if (typeof cents === "string") {
        cents = cents.replace(".", "");
    }
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
        formatString = format || window.moneyFormat;

    function defaultTo(value2, defaultValue) {
        return value2 == null || value2 !== value2 ? defaultValue : value2;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultTo(precision, 2);
        thousands = defaultTo(thousands, ",");
        decimal = defaultTo(decimal, ".");
        if (isNaN(number) || number == null) {
            return 0;
        }
        number = (number / 100).toFixed(precision);
        let parts = number.split("."),
            dollarsAmount = parts[0].replace(
                /(\d)(?=(\d\d\d)+(?!\d))/g,
                "$1" + thousands
            ),
            centsAmount = parts[1] ? decimal + parts[1] : "";
        return dollarsAmount + centsAmount;
    }
    let value = "";
    switch (formatString.match(placeholderRegex)[1]) {
        case "amount":
            value = formatWithDelimiters(cents, 2);
            break;
        case "amount_no_decimals":
            value = formatWithDelimiters(cents, 0);
            break;
        case "amount_with_space_separator":
            value = formatWithDelimiters(cents, 2, " ", ".");
            break;
        case "amount_with_comma_separator":
            value = formatWithDelimiters(cents, 2, ".", ",");
            break;
        case "amount_with_apostrophe_separator":
            value = formatWithDelimiters(cents, 2, "'", ".");
            break;
        case "amount_no_decimals_with_comma_separator":
            value = formatWithDelimiters(cents, 0, ".", ",");
            break;
        case "amount_no_decimals_with_space_separator":
            value = formatWithDelimiters(cents, 0, " ");
            break;
        case "amount_no_decimals_with_apostrophe_separator":
            value = formatWithDelimiters(cents, 0, "'");
            break;
    }
    if (formatString.indexOf("with_comma_separator") !== -1) {
        return formatString.replace(placeholderRegex, value);
    } else {
        return formatString.replace(placeholderRegex, value);
    }
}

class CustomHTMLElement extends HTMLElement {
    constructor() {
        super();
        this._hasSectionReloaded = false;
    }

    get delegate() {
        if (!this._delegate) {
            this._delegate = {
                on: (eventName, selector, callback) => {
                    this.addEventListener(eventName, (event) => {
                        if (event.target.matches(selector)) {
                            callback(event);
                        }
                    });
                },
                destroy: () => {}
            };
        }
        return this._delegate;
    }

    disconnectedCallback() {
        if (this._delegate) {
            this._delegate.destroy();
        }
    }
}

class QuantitySelector extends HTMLElement {
  connectedCallback() {
    this.inputElement = this.querySelector('.quantity-selector__input');

    this.addEventListener('click', (e) => {
      const incBtn = e.target.closest('.qty-increase-btn');
      const decBtn = e.target.closest('.qty-reduce-btn');
      if (!incBtn && !decBtn) return;

      const input = this.inputElement;
      if (!input) return;

      const min = parseInt(input.min || '1', 10);
      const max = input.max ? parseInt(input.max, 10) : Number.MAX_SAFE_INTEGER;

      let val = parseInt(input.value || String(min), 10);
      if (Number.isNaN(val)) val = min;

      val = incBtn ? val + 1 : val - 1;
      val = Math.max(min, Math.min(val, max));

      input.value = String(val);
      input.size = Math.max(input.value.length + 1, 2);

      // deine bestehenden Listener bedienen
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
      input.dispatchEvent(new CustomEvent('quantity-change', {
        bubbles: true,
        composed: true,
        detail: { value: input.value }
      }));
    });

    // Optional: wenn User tippt, auch quantity-change feuern
    if (this.inputElement) {
      this.inputElement.addEventListener('input', () => {
        const input = this.inputElement;
        const min = parseInt(input.min || '1', 10);
        let val = parseInt(input.value || String(min), 10);
        if (Number.isNaN(val) || val < min) val = min;
        input.value = String(val);

        input.dispatchEvent(new CustomEvent('quantity-change', {
          bubbles: true,
          composed: true,
          detail: { value: input.value }
        }));
      });
    }
  }
}

customElements.define('quantity-selector', QuantitySelector);

/*
class QuantitySelector extends CustomHTMLElement {
    connectedCallback() {
        this.inputElement = this.querySelector('input[type="text"][is="input-number"]');

        this.delegate.on('click', 'button:first-child', () => {
            this.inputElement.quantity = this.inputElement.quantity - 1;
        });

        this.delegate.on('click', 'button:last-child', () => {
            this.inputElement.quantity = this.inputElement.quantity + 1;
        });
    }
}

class InputNumber extends HTMLInputElement {
    connectedCallback() {
        this.addEventListener('input', this._onValueInput.bind(this));
        this.addEventListener('change', this._onValueChanged.bind(this));
        this.addEventListener('keydown', this._onKeyDown.bind(this));
    }

    get quantity() {
        return parseInt(this.value) || 1;
    }

    set quantity(quantity) {
        const isNumeric = (typeof quantity === 'number' ||
                (typeof quantity === 'string' && quantity.trim() !== '')) &&
            !isNaN(quantity);

        if (quantity === '') return;

        if (!isNumeric || quantity < 0) {
            quantity = parseInt(quantity) || 1;
        }


        const min = this.min ? parseInt(this.min) : 1;
        const max = this.max ? parseInt(this.max) : Number.MAX_SAFE_INTEGER;

        this.value = Math.max(min, Math.min(quantity, max)).toString();
        this.size = Math.max(this.value.length + 1, 2);

        this.dispatchEvent(new CustomEvent('quantity-change', {
            bubbles: true,
            detail: {
                value: this.value
            }
        }));
    }

    _onValueInput() {
        this.quantity = this.value;
    }

    _onValueChanged() {
        if (this.value === '') {
            this.quantity = 1;
        }
    }

    _onKeyDown(event) {
        event.stopPropagation();

        if (event.key === 'ArrowUp') {
            event.preventDefault();
            this.quantity = this.quantity + 1;
        } else if (event.key === 'ArrowDown') {
            event.preventDefault();
            this.quantity = this.quantity - 1;
        }
    }
}

customElements.define('quantity-selector', QuantitySelector);
customElements.define('input-number', InputNumber, {
    extends: 'input'
});*/

const bundleProducts = [];


function findProductInArray(variantId) {
    return bundleProducts.findIndex(product => product.variant_id === variantId);
}


function updateProductQuantity(variantId, quantity) {
    const index = findProductInArray(variantId);
    if (index !== -1) {
        bundleProducts[index].quantity = quantity;
        updateBundleFooter();
    }
}

function updateProductPrice(variantId, price) {
    const index = findProductInArray(variantId);
    if (index !== -1) {
        bundleProducts[index].price = price;
        updateBundleFooter();
    }
}


function removeProductFromArray(variantId) {
    const index = findProductInArray(variantId);
    if (index !== -1) {
        bundleProducts.splice(index, 1);
        updateBundleFooter();
    }
}


function parsePrice(priceString) {
    return parseFloat(priceString.replace(/[^\d,]/g, '').replace(',', '.'));
}


function updateProductDataAttributes(productElement, variantId, price) {
    productElement.setAttribute('data-variant_id', variantId);
    productElement.setAttribute('data-variant-price', price);
}


function updateBundleFooter() {
    const selectedProductsContainer = document.querySelector('.cp-bundle-selected-products');
    const mobileSelectedProductsContainer = document.querySelector('.mobile-only.cp-bundle-selected-products');

    if (!selectedProductsContainer) return;

    const existingProducts = selectedProductsContainer.querySelectorAll('.cp-bundle-selected-product');
    existingProducts.forEach(product => product.remove());

    bundleProducts.forEach(product => {
        const productElement = document.createElement('div');
        productElement.className = 'cp-bundle-selected-product';
        productElement.innerHTML = `
            <div class="cp-bundle-selected-product-inner">
                <div class="cp-bundle-selected-product-img">
                    <span class="cp-bundle-selected-product-close" data-variant-id="${product.variant_id}">
                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                            <path d="M9.64052 9.10965C9.67536 9.14449 9.703 9.18586 9.72186 9.23138C9.74071 9.2769 9.75042 9.32569 9.75042 9.37496C9.75042 9.42424 9.74071 9.47303 9.72186 9.51855C9.703 9.56407 9.67536 9.60544 9.64052 9.64028C9.60568 9.67512 9.56432 9.70276 9.51879 9.72161C9.47327 9.74047 9.42448 9.75017 9.37521 9.75017C9.32594 9.75017 9.27714 9.74047 9.23162 9.72161C9.1861 9.70276 9.14474 9.67512 9.1099 9.64028L6.00021 6.53012L2.89052 9.64028C2.82016 9.71064 2.72472 9.75017 2.62521 9.75017C2.5257 9.75017 2.43026 9.71064 2.3599 9.64028C2.28953 9.56991 2.25 9.47448 2.25 9.37496C2.25 9.27545 2.28953 9.18002 2.3599 9.10965L5.47005 5.99996L2.3599 2.89028C2.28953 2.81991 2.25 2.72448 2.25 2.62496C2.25 2.52545 2.28953 2.43002 2.3599 2.35965C2.43026 2.28929 2.5257 2.24976 2.62521 2.24976C2.72472 2.24976 2.82016 2.28929 2.89052 2.35965L6.00021 5.46981L9.1099 2.35965C9.18026 2.28929 9.2757 2.24976 9.37521 2.24976C9.47472 2.24976 9.57016 2.28929 9.64052 2.35965C9.71089 2.43002 9.75042 2.52545 9.75042 2.62496C9.75042 2.72448 9.71089 2.81991 9.64052 2.89028L6.53036 5.99996L9.64052 9.10965Z" fill="black"></path>
                        </svg>
                    </span>
                    <img src="${product.product_image}" alt="${product.product_title}">
                </div>
                <div class="cp-bundle-selected-product-detail">
                    <h4 class="cp-bundle-selected-product-title">${product.product_title}</h4>
                    <div class="cp-bundle-selected-product-qty-price">
                        <span class="cp-bundle-selected-product-qty">${product.quantity}x</span>
                        <span class="cp-bundle-selected-product-price">${formatMoney(product.price, window.currencyFormat)}</span>
                    </div>
                </div>
            </div>
        `;

        selectedProductsContainer.appendChild(productElement);
    });


    if (mobileSelectedProductsContainer) {
        mobileSelectedProductsContainer.innerHTML = selectedProductsContainer.innerHTML;
    }


    updateProgressBar();
}


function updateProgressBar() {
    const threshold = parseFloat(
        document.querySelector(".bundle-progressbar").getAttribute("threshold")
    );

    const totalBundlePrice = bundleProducts.reduce((total, product) => {
        return total + (product.price * product.quantity);
    }, 0);

    let progress = (totalBundlePrice / threshold) * 100;
    if (progress > 100) progress = 100;

    // Support multiple StickyAtcs
    const progressBars = document.querySelectorAll('.bundle-progressbar-active');

    if (!progressBars.length) {
    console.error('Progress bar elements not found!');
    } else {
    progressBars.forEach(bar => {
        bar.style.width = `${progress}%`;
    });
    }

    const progressMessages = document.querySelectorAll(".progressMessage");
    const blocks = document.querySelectorAll(".progressbar-discount");
    const bundle_price = document.querySelector(".bundle-total-price");

    const totalDataP = bundleProducts.reduce((total, product) => {
        return total + (product.price * product.quantity);
    }, 0);

    let appliedDiscount = 0;
    let nearestThreshold = null;
    let nearestDiscount = null;
    let remainingAmount = null;
    let hasActiveDiscount = false;

    blocks.forEach((block) => {
        const blockThreshold = parseFloat(
            block.querySelector(".treshold").getAttribute("data-value")
        );
        const discount = parseFloat(
            block.querySelector(".treshold").textContent.replace('%', '')
        );

        if (totalBundlePrice >= blockThreshold) {
            block.classList.add("active");
            appliedDiscount = Math.max(appliedDiscount, discount);
            hasActiveDiscount = true;
        } else {
            block.classList.remove("active");
            if (nearestThreshold === null || blockThreshold < nearestThreshold) {
                nearestThreshold = blockThreshold;
                nearestDiscount = discount;
                remainingAmount = blockThreshold - totalBundlePrice;
            }
        }
    });

    let message = "";

    if (progress === 100) {
        message = progressbar_message_discount_applied_all;
    } else if (hasActiveDiscount) {
        message = progressbar_message_discount_applied
            .replace("[applied_discount]", `<strong>${appliedDiscount}%</strong>`)
            .replace("[amount]", `<strong>${formatMoney(remainingAmount, window.currencyFormat)}</strong>`)
            .replace("[discount]", `<strong>${nearestDiscount}%</strong>`);
    } else {
        message = progressbar_message_initial
            .replace("[amount]", `<strong>${formatMoney(remainingAmount, window.currencyFormat)}</strong>`)
            .replace("[discount]", `<strong>${nearestDiscount}%</strong>`);
    }
   
    if (!progressMessages.length) {
        console.error('Progress message elements not found!');
    } else {
        progressMessages.forEach(el => {
            el.innerHTML = message;
        });
    }

    const comparePrice = totalDataP;
    const salePrice = (
        Math.ceil((totalDataP * (100 - appliedDiscount)) / 100)
    );
    const savedAmount = (
        comparePrice - salePrice
    );

    // querySelectorAll to support multiple Sticky ATCs 
    const endPriceCompareEls = document.querySelectorAll('.cp-bundle-end-price-compare');
    const endPriceOriginalEls = document.querySelectorAll('.cp-bundle-end-price-original');
    const endPriceDiscountEls = document.querySelectorAll('.cp-bundle-end-price-discount');

    const hasAll =
    endPriceCompareEls.length &&
    endPriceOriginalEls.length &&
    endPriceDiscountEls.length;

    if (!hasAll) {
    console.error('One or more end price elements not found!');
    } else {
    const showCompare = comparePrice !== salePrice;

    const compareText = showCompare ? formatMoney(comparePrice, window.currencyFormat) : '';
    const originalText = formatMoney(salePrice, window.currencyFormat);
    const discountText = showCompare ? `-${appliedDiscount}%` : '';

    endPriceCompareEls.forEach(el => (el.textContent = compareText));
    endPriceOriginalEls.forEach(el => (el.textContent = originalText));
    endPriceDiscountEls.forEach(el => (el.textContent = discountText));
    }

    const labels = document.querySelectorAll('.cp-bundle-end-price-label');

    if (!labels.length) {
    console.error('Price label elements not found!');
    } else {
    labels.forEach(label => {
        label.textContent = `Alle ${bundleProducts.length} Artikel:`;
    });
    }
}

document.addEventListener('click', function(e) {
    if (e.target.closest('.button-product-atc')) {
        const button = e.target.closest('.button-product-atc');
        const productElement = button.closest('.cp-bundle-builder-product');

        if (productElement) {
            productElement.classList.add('selected');

            const variantId = productElement.getAttribute('data-variant_id');
            const productImage = productElement.getAttribute('data-product_image');
            const productTitle = productElement.getAttribute('data-product_title');
            const price = parsePrice(productElement.getAttribute('data-variant-price'));
            const quantityInput = productElement.querySelector('.quantity-selector__input');
            const quantity = quantityInput ? parseInt(quantityInput.value) : 1;

            const existingIndex = findProductInArray(variantId);

            if (existingIndex === -1) {
                bundleProducts.push({
                    variant_id: variantId,
                    product_image: productImage,
                    product_title: productTitle,
                    price: price,
                    quantity: quantity
                });
            } else {

                bundleProducts[existingIndex].quantity = quantity;
                bundleProducts[existingIndex].price = price;
            }

            console.log('Product added to bundle:', bundleProducts);
            updateBundleFooter();
        }
    }
    if (e.target.closest('.qty-reduce-btn')) {
        const reduceBtn = e.target.closest('.qty-reduce-btn');
        const quantityInput = reduceBtn.nextElementSibling;

        if (quantityInput && quantityInput.classList.contains('quantity-selector__input')) {
            const currentValue = parseInt(quantityInput.value);

            if (currentValue === 1) {
                const productElement = reduceBtn.closest('.cp-bundle-builder-product');

                if (productElement) {

                    productElement.classList.remove('selected');

                    const variantId = productElement.getAttribute('data-variant_id');
                    removeProductFromArray(variantId);

                    console.log('Product removed from bundle:', bundleProducts);
                }
            }
        }
    }


    if (e.target.closest('.cp-bundle-selected-product-close')) {
        const closeBtn = e.target.closest('.cp-bundle-selected-product-close');
        const variantId = closeBtn.getAttribute('data-variant-id');


        removeProductFromArray(variantId);

        const productElement = document.querySelector(`.cp-bundle-builder-product[data-variant_id="${variantId}"]`);
        if (productElement) {
            productElement.classList.remove('selected');

            const quantityInput = productElement.querySelector('.quantity-selector__input');
            if (quantityInput) {
                quantityInput.value = '1';
            }
        }

        console.log('Product removed via close button:', bundleProducts);
    }
});


document.addEventListener('quantity-change', function(e) {
    const quantityInput = e.target;

    if (quantityInput.classList.contains('quantity-selector__input')) {
        const productElement = quantityInput.closest('.cp-bundle-builder-product');

        if (productElement) {
            const variantId = productElement.getAttribute('data-variant_id');
            const quantity = parseInt(quantityInput.value);


            updateProductQuantity(variantId, quantity);

            console.log('Quantity updated (custom event):', bundleProducts);

            if (quantity === 1) {

                const eventPath = e.composedPath && e.composedPath();
                const wasReduced = eventPath && eventPath.some(el =>
                    el.classList && el.classList.contains('qty-reduce-btn')
                );

                if (wasReduced) {
                    productElement.classList.remove('selected');
                    removeProductFromArray(variantId);
                    console.log('Product removed via reduce button:', bundleProducts);
                }
            }
        }
    }
});


document.addEventListener('change', function(e) {
    if (e.target.closest('.bundle-product-variants select')) {
        const select = e.target;
        const productElement = select.closest('.cp-bundle-builder-product');

        if (productElement) {
            const selectedOption = select.options[select.selectedIndex];
            const variantId = selectedOption.value;
            const price = parsePrice(selectedOption.getAttribute('data-price'));


            updateProductDataAttributes(productElement, variantId, price);

            const priceElement = productElement.querySelector('.bundle-product-price');
            if (priceElement) {
                priceElement.textContent = formatMoney(price, window.currencyFormat);
            }


            const existingIndex = findProductInArray(productElement.getAttribute('data-variant_id'));

            if (existingIndex !== -1) {

                bundleProducts[existingIndex].variant_id = variantId;
                bundleProducts[existingIndex].price = price;

                console.log('Variant updated in bundle:', bundleProducts);
                updateBundleFooter();
            }
        }
    }
});

document.addEventListener('input', function(e) {
    if (e.target.classList.contains('quantity-selector__input')) {
        const quantityInput = e.target;
        const productElement = quantityInput.closest('.cp-bundle-builder-product');

        if (productElement) {
            const variantId = productElement.getAttribute('data-variant_id');
            const quantity = parseInt(quantityInput.value);


            updateProductQuantity(variantId, quantity);

            console.log('Quantity updated (input event):', bundleProducts);
        }
    }
});

document.addEventListener('change', function(e) {
    if (e.target.classList.contains('quantity-selector__input')) {
        const quantityInput = e.target;
        const productElement = quantityInput.closest('.cp-bundle-builder-product');

        if (productElement) {
            const variantId = productElement.getAttribute('data-variant_id');
            const quantity = parseInt(quantityInput.value);

            updateProductQuantity(variantId, quantity);

            console.log('Quantity updated (change event):', bundleProducts);
        }
    }
});


document.addEventListener('DOMContentLoaded', function() {
    updateBundleFooter();
});


document.addEventListener('click', function(e) {
    if (e.target.closest('#cp-bundle-atc')) {
        e.preventDefault();
        const formData = {
            'items': bundleProducts.map(product => ({
                'id': parseInt(product.variant_id),
                'quantity': product.quantity,
                'properties' : {
                    '_bundle_product' : true
                }
            }))
        };
        fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            })
            .then(response => response.json())
            .then(response => {
                window.location.href = '/cart';
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }
});




function handleFilterClick(event) {
    const clickedElement = event.currentTarget;
    const isCategoryFilter = clickedElement.classList.contains('bundle-category-filter-label');
    const isEditionFilter = clickedElement.classList.contains('bundle-edition-filter-label');
    const isCollectionTab = clickedElement.classList.contains('bundle-collection-tab-switch');

    if (isCategoryFilter) {
        document.querySelectorAll('.bundle-category-filter-label').forEach(label => {
            label.classList.remove('active');
        });
        clickedElement.classList.add('active');

    updateTeasers();
    updateFilterUrl();
    } else if (isEditionFilter) {

        document.querySelectorAll('.bundle-edition-filter-label').forEach(label => {
            label.classList.remove('active');
        });

        clickedElement.classList.add('active');

    updateTeasers();
    updateFilterUrl();
    } else if (isCollectionTab) {
        document.querySelectorAll('.bundle-collection-tab-switch').forEach(label => {
            label.classList.remove('active');
        });
        clickedElement.classList.add('active');

        const tabBlock = clickedElement.dataset.block;
        document.querySelectorAll('.bundle-collection-tab-products').forEach(tab => {
            tab.classList.remove('active');
            if (tab.dataset.block === tabBlock) {
                tab.classList.add('active');
            }
        });
    }

}


function updateTeasers() {
    const activeCategory = document.querySelector('.bundle-category-filter-label.active');
    const activeCategoryBlock = activeCategory ? activeCategory.dataset.block : '';
    document.querySelectorAll('.category-filter-teaser').forEach(teaser => {
        teaser.classList.remove('active');
        if (teaser.dataset.block === activeCategoryBlock) {
            teaser.classList.add('active');
        }
    });

    const activeEdition = document.querySelector('.bundle-edition-filter-label.active');
    const activeEditionBlock = activeEdition ? activeEdition.dataset.block : '';
    document.querySelectorAll('.category-edition-teaser').forEach(teaser => {
        teaser.classList.remove('active');
        if (teaser.dataset.block === activeEditionBlock) {
            teaser.classList.add('active');
        }
    });
}

function generateFilterUrl() {
    const categoryValue = document.querySelector('.bundle-category-filter-label.active')?.dataset.label || '';
    const editionValue = document.querySelector('.bundle-edition-filter-label.active')?.dataset.label || '';
    const collectionTabValue = document.querySelector('.bundle-collection-tab-switch.active')?.textContent.trim() || '';

    let url = '';

    if (categoryValue) {
        url += `filter.p.m.custom.cp_bundle_category=${encodeURIComponent(categoryValue)}`;
    }

    if (editionValue) {
        if (url) url += '&';
        url += `filter.p.m.custom.cp_bundle_edition=${encodeURIComponent(editionValue)}`;
    }

    if (!editionValue && collectionTabValue) {
        if (url) url += '&';
        url += `filter.p.m.custom.cp_bundle_edition=${encodeURIComponent(collectionTabValue)}`;
    }

    return url;
}

function updateFilterUrl() {
    const filterUrl = generateFilterUrl();
    const newUrl = window.location.origin + window.location.pathname + (filterUrl ? '?' + filterUrl : '');
    window.history.pushState({
        path: newUrl
    }, '', newUrl);
    fetch(newUrl)
        .then(response => response.text())
        .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const newProducts = doc.querySelector('.cp-bundle-builder-products');
            if (newProducts) {
                const currentProducts = document.querySelector('.cp-bundle-builder-products');
                if (currentProducts) {
                    currentProducts.innerHTML = newProducts.innerHTML;
                }
            }
        })
        .catch(err => console.error('Error fetching updated products:', err));
}


document.addEventListener('DOMContentLoaded', function() {

    document.querySelectorAll('.bundle-category-filter-label, .bundle-edition-filter-label, .bundle-collection-tab-switch').forEach(element => {
        element.addEventListener('click', handleFilterClick);
    });

    // updateTeasers();

    // updateFilterUrl();
});




document.addEventListener("DOMContentLoaded", function () {
  const bundle_footer = document.querySelector(".cp-bundle-builder-footer");
  if (!bundle_footer) return;

  const sentinel = document.createElement("div");
  sentinel.classList.add("sticky-sentinel");
  bundle_footer.parentNode.insertBefore(sentinel, bundle_footer);

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        // Wenn Sentinel sichtbar ist, ist der Footer in der Nähe -> nicht sticky
        if (entry.isIntersecting) {
          bundle_footer.classList.remove("sticky-footer");
          return;
        }

        // Sentinel ist NICHT sichtbar -> kann oben ODER unten außerhalb liegen
        const viewportH = entry.rootBounds?.height || window.innerHeight;

        // Nur sticky, wenn Sentinel unterhalb des Viewports liegt
        const isBelowViewport = entry.boundingClientRect.top > viewportH;

        if (isBelowViewport) {
          bundle_footer.classList.add("sticky-footer");
        } else {
          // Sentinel ist oberhalb -> Footer wurde schon "über-scrollt" -> nicht sticky
          bundle_footer.classList.remove("sticky-footer");
        }
      });
    },
    {
      threshold: 0,
      rootMargin: "0px"
    }
  );

  observer.observe(sentinel);

  const style = document.createElement("style");
  style.textContent = `
    .cp-bundle-builder-footer { transition: transform 0.3s ease; }
    .sticky-footer {
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: 1000;
      box-shadow: 0 -2px 10px rgba(0,0,0,0.1);
    }
    .sticky-sentinel { height: 1px; width: 100%; }
  `;
  document.head.appendChild(style);
});
